import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import CircleProgress from "vue3-circle-progress";
import './assets/Css/App.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
createApp(App).use(store).use(router).use(CircleProgress).mount('#app')
